import { createAsyncThunk } from '@reduxjs/toolkit';
import AssignmentApi from '@infrastructure/assignment-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import { translate } from '@application/common/helpers/translate';
import { addSuccessNotification } from '../common/notificationSlice';
export const addAssignmentAsync = createAsyncThunk('assignment/add', async (assignment, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.addAssignment(assignment);
        dispatch(addSuccessNotification(translate('assignment.assignmentAddedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateAssignmentAsync = createAsyncThunk('assignment/UpdateAssignment', async (assignment, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.updateAssignment(assignment);
        dispatch(addSuccessNotification(translate('assignment.assignmentUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentByStatusAsync = createAsyncThunk('assignment/getByStatus', async (status, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.getAssignmentsByStatus(status);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentByApprovedTimsheetAsync = createAsyncThunk('assignment/getAssignmentsWithApprovedTimeSheet', async (_, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.getAssignmentsWithApprovedTimeSheet();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentByStatusWithReasonAsync = createAsyncThunk('assignment/getByStatusWithReason', async (status, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.getAssignmentsByStatusWithReason(status);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentsAsync = createAsyncThunk('assignment/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AssignmentApi.getAssignments();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getAssignmentDetailByIdAsync = createAsyncThunk('assignment/getDetailById', async (assignmentId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AssignmentApi.getAssignmentDetailById(assignmentId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getAssignmentByIdAsync = createAsyncThunk('assignment/GetAssignmentById', async (assignmentId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AssignmentApi.getAssignmentById(assignmentId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateAssignmentContractAsync = createAsyncThunk('assignment/updateAssignmentContract', async (contract, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.updateAssignmentContract(contract);
        dispatch(addSuccessNotification(translate('assignment.assignmentUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateAssignmentContractEndDateAsync = createAsyncThunk('assignment/updateAssignmentContractEndDate', async (contract, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.updateAssignmentContractEndDate(contract);
        dispatch(addSuccessNotification(translate('assignment.assignmentUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const generateAutoContractAsync = createAsyncThunk('assignment/generateAutoContract', async (assignment, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AssignmentApi.generateAutoContract(assignment);
        return fulfillWithValue(response.data.contractHtml);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
